import { RefObject, useEffect } from 'react';

const preventWheelZoom = (event: WheelEvent) => {
  if (event.ctrlKey) {
    event.preventDefault();
  }
};

export const usePreventWheelZoom = (
  ref: RefObject<HTMLElement | null>
): void => {
  useEffect(() => {
    const container = ref.current;
    if (!container) {
      return;
    }
    container.addEventListener('wheel', preventWheelZoom, { passive: false });
    return () => container.removeEventListener('wheel', preventWheelZoom);
  }, [ref]);
};
